export default __webpack_public_path__ + "static/media/007-broom.03ca52b2.svg";